import { CtaButtonType, CtaForm } from '@pairy/sheard/types';

import { BulkFileResponseType } from '../../../types/file';
import { EmbedItemType, MessageBoxItemType } from '../../PdfViewer/index.types';
import { adaptBulkDocument } from '../index.types';
import V2ViewerShell from '../V2ViewerShell';

interface Props {
  data: BulkFileResponseType;
  messageBoxItems?: MessageBoxItemType[];
  embedItems?: EmbedItemType[];
  ctaButtonList?: CtaButtonType[];
  ctaForm?: CtaForm;
  translateKoToEn: (item: string) => string;
}

/** 벌크 공유 PDF(CTA 포함)의 V2 뷰어 진입점 */
const V2BulkViewer = ({
  data,
  messageBoxItems,
  embedItems,
  ctaButtonList,
  ctaForm,
  translateKoToEn,
}: Props) => {
  return (
    <V2ViewerShell
      document={adaptBulkDocument(data)}
      isBulk
      domain={data.user.domain}
      messageBoxItems={messageBoxItems}
      embedItems={embedItems}
      cta={{
        ctaForm,
        ctaButtonList,
        isEmailVerificationEnabled: data.file.isEmailVerificationEnabled,
        isFormSubmitted: data.file.isFormSubmitted,
      }}
      translateKoToEn={translateKoToEn}
    />
  );
};

export default V2BulkViewer;
